import { OrganisationType } from '@/shared/types/enum';

/** Organisation types that are always charities. */
export const CHARITY_ORGANISATION_TYPES = [
  OrganisationType.CharitableAssociation,
  OrganisationType.CharitableCompany,
  OrganisationType.CharitableTrust,
  OrganisationType.CIO,
  OrganisationType.SCIO,
] as const;

/** Types for which the Charity switch is enabled. */
export const CHARITY_TOGGLE_ENABLED_ORGANISATION_TYPES = [
  OrganisationType.LimitedCompany,
  OrganisationType.CharitableCompany,
] as const;

/** Types that have a Companies House / company registration number. */
export const COMPANY_REGISTRATION_ORGANISATION_TYPES = [
  OrganisationType.LimitedCompany,
  OrganisationType.LimitedPartnership,
  OrganisationType.LimitedLiabilityPartnership,
  OrganisationType.CharitableCompany,
  OrganisationType.CIC,
  OrganisationType.CIO,
  OrganisationType.SCIO,
] as const;

export const isCharityOrganisationType = (type: string | null | undefined) =>
  !!type && (CHARITY_ORGANISATION_TYPES as readonly string[]).includes(type);

export const isCharityToggleEnabledOrganisationType = (type: string | null | undefined) =>
  !!type && (CHARITY_TOGGLE_ENABLED_ORGANISATION_TYPES as readonly string[]).includes(type);

export const isCompanyRegistrationOrganisationType = (type: string | null | undefined) =>
  !!type && (COMPANY_REGISTRATION_ORGANISATION_TYPES as readonly string[]).includes(type);

export const isCioOrScioOrganisationType = (type: string | null | undefined) =>
  type === OrganisationType.CIO || type === OrganisationType.SCIO;

export const hidesAccountsAndConfirmationStatement = (type: string | null | undefined) =>
  isCioOrScioOrganisationType(type) ||
  type === OrganisationType.CharitableTrust ||
  type === OrganisationType.CharitableAssociation;
